// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"92":"8d7fa27b","700":"c1281c59"}[chunkId] + ".css";
};